export type NewsItem = {
  id: string;
  title: string;
  date: string;
  category: string;
  summary: string;
  cover: string;
  content: string[];
  relatedIds: string[];
};

export const newsList: NewsItem[] = [
  {
    id: "n001",
    title: "《长风渡月》收官收视破纪录，古装剧市场再迎热潮",
    date: "2025-10-14",
    category: "剧集动态",
    summary:
      "由陈默然执导的古装剧《长风渡月》于前日迎来大结局，收官夜全国收视份额刷新本年度古装剧纪录，网络热度持续登顶。",
    cover:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20courtyard%20at%20dusk%20with%20warm%20amber%20lanterns%20and%20deep%20navy%20sky%2C%20cinematic%20editorial%20news%20photo%20style%2C%20high%20detail&width=800&height=500&seq=news-cover-01&orientation=landscape",
    content: [
      "由陈默然执导、林清源与苏晚晴领衔主演的古装剧《长风渡月》于前日晚迎来大结局。据收视数据显示，收官之夜该剧全国收视份额达到本年度古装题材的最高值，多个网络平台热度榜单同时登顶。",
      "该剧自开播以来，凭借扎实的剧本、细腻的人物塑造和精良的制作水准，收获了观众的广泛好评。剧中“长风渡口”等重要场景更成为社交平台上的讨论热点，相关话题阅读量持续攀升。",
      "业内人士分析认为，《长风渡月》的成功再次印证了观众对于高质量原创古装内容的旺盛需求。在流量红利逐渐消退的当下，扎实的内容与用心的制作正在成为剧集突围的关键。",
      "据悉，制作方已透露正在筹备相关的衍生内容，主创团队也将于近期参与多场线上交流活动，与观众分享创作幕后故事。",
    ],
    relatedIds: ["n002", "n008"],
  },
  {
    id: "n002",
    title: "2025年国产剧集备案数量创新高，现实题材成主流",
    date: "2025-10-10",
    category: "行业观察",
    summary:
      "最新公布的备案数据显示，2025年国产剧集立项数量同比增长明显，其中现实题材占比超过六成，成为市场绝对主流。",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20minimalist%20film%20production%20office%20with%20storyboards%20and%20warm%20amber%20desk%20lamp%20light%2C%20deep%20navy%20accents%2C%20editorial%20photography%20style%2C%20high%20detail&width=800&height=500&seq=news-cover-02&orientation=landscape",
    content: [
      "近日公布的年度剧集备案数据显示，2025年国产剧集立项数量同比增长明显，创下近年新高。其中，现实题材剧集占比超过六成，成为市场绝对主流。",
      "从题材分布来看，都市生活、职场奋斗、家庭情感等贴近普通人日常的题材受到制作方青睐；与此同时，悬疑、科幻等类型化创作的比重也在稳步提升，显示出市场的多元化趋势。",
      "多位从业者在采访中表示，观众审美日趋成熟，对内容真实感与情感共鸣的要求越来越高，这促使创作者把更多精力投入到剧本打磨与生活观察之中。",
      "分析认为，备案数量的增长既是行业活力的体现，也对内容质量提出了更高要求。如何在数量增长的同时保持品质，将是下一阶段行业共同面对的课题。",
    ],
    relatedIds: ["n010", "n008"],
  },
  {
    id: "n003",
    title: "《暗夜追凶》第二季正式官宣，原班人马悉数回归",
    date: "2025-10-06",
    category: "剧集动态",
    summary:
      "备受期待的悬疑剧《暗夜追凶》确认启动第二季，主创团队与主要演员将原班回归，剧本已进入最后打磨阶段。",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20city%20alley%20at%20night%20lit%20by%20a%20single%20amber%20street%20lamp%20with%20deep%20navy%20shadows%2C%20crime%20drama%20editorial%20style%2C%20high%20detail&width=800&height=500&seq=news-cover-03&orientation=landscape",
    content: [
      "备受观众期待的悬疑剧《暗夜追凶》正式官宣启动第二季。制作方确认，导演叶南舟与主演陆星辰、江若彤等主创团队将原班回归，延续第一季的故事世界。",
      "第一季凭借缜密的推理逻辑与高能反转的叙事节奏，在播出期间长期占据讨论热度前列，结局留下的悬念也让观众对后续剧情充满期待。",
      "据透露，第二季剧本目前已进入最后的打磨阶段，新一季将在保留原有风格的基础上，引入全新的案件线索与人物关系，力求在悬念设计上更进一步。",
      "制作方表示，新一季的拍摄工作计划于明年初启动，具体播出时间将另行公布。",
    ],
    relatedIds: ["n001", "n009"],
  },
  {
    id: "n004",
    title: "仙侠题材回暖：多部古装仙侠剧集扎堆开播",
    date: "2025-09-30",
    category: "行业观察",
    summary:
      "进入下半年，多部古装仙侠题材剧集集中开播，这一曾经的热门类型正以更精良的制作水准重新回到观众视野。",
    cover:
      "https://readdy.ai/api/search-image?query=Floating%20immortal%20mountain%20peaks%20above%20a%20sea%20of%20clouds%20with%20warm%20amber%20glow%20and%20deep%20navy%20sky%2C%20fantasy%20editorial%20style%2C%20high%20detail&width=800&height=500&seq=news-cover-04&orientation=landscape",
    content: [
      "进入下半年，多部古装仙侠题材剧集集中开播，这一曾经风靡市场的热门类型，正以更加精良的制作水准重新回到观众的视野之中。",
      "与早年相比，新一批仙侠剧在特效呈现、世界观构建和人物塑造上都有了明显提升。创作者不再单纯依赖“流量＋IP”的组合，而是更注重故事内在的逻辑与情感表达。",
      "有评论指出，仙侠题材的核心魅力在于对东方奇幻美学的呈现以及对成长、抉择等永恒命题的探讨。能否讲好故事，仍是决定作品成败的关键。",
      "业内预计，随着多部重点作品的陆续上线，仙侠题材有望在未来一段时间内持续保持较高的市场关注度。",
    ],
    relatedIds: ["n002", "n007"],
  },
  {
    id: "n005",
    title: "暑期档电影市场观察：科幻与现实题材双线开花",
    date: "2025-09-18",
    category: "票房数据",
    summary:
      "今年暑期档电影市场呈现科幻与现实题材双线开花的格局，多部中小成本作品凭借口碑实现逆袭。",
    cover:
      "https://readdy.ai/api/search-image?query=Deep%20space%20nebula%20with%20a%20distant%20glowing%20planet%20in%20deep%20navy%20and%20warm%20amber%20tones%2C%20sci-fi%20editorial%20style%2C%20high%20detail&width=800&height=500&seq=news-cover-05&orientation=landscape",
    content: [
      "今年暑期档电影市场整体表现稳健，科幻与现实题材呈现双线开花的格局。国产科幻作品在视觉呈现与叙事表达上均有突破，而关注普通人生活的现实题材作品同样收获了不俗口碑。",
      "值得注意的是，多部中小成本影片凭借扎实的口碑实现票房逆袭，长线放映的成绩印证了“内容为王”的市场规律。观众的购票决策愈发理性，口碑传播在票房走势中的作用愈发明显。",
      "从观众结构来看，年轻观众仍是观影主力，但家庭观影与中年观众群体也在稳步增长，市场结构更加均衡。",
      "业内普遍认为，暑期档的良好表现为全年电影市场注入了信心，接下来国庆档与贺岁档的表现同样值得期待。",
    ],
    relatedIds: ["n002", "n010"],
  },
  {
    id: "n006",
    title: "亚洲影视合作深化，多部合拍剧集进入制作阶段",
    date: "2025-09-08",
    category: "行业观察",
    summary:
      "随着区域影视交流日益频繁，多部跨国合拍剧集陆续进入制作阶段，为观众带来更多元的文化视角。",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20international%20film%20studio%20with%20staff%20collaborating%20under%20warm%20amber%20light%20and%20deep%20navy%20shadows%2C%20editorial%20style%2C%20high%20detail&width=800&height=500&seq=news-cover-06&orientation=landscape",
    content: [
      "随着区域内影视交流日益频繁，多部跨国合拍剧集陆续进入制作阶段。合作方在剧本开发、拍摄制作与市场发行等环节展开深度协作，为观众带来更多元的文化视角。",
      "参与合拍的项目题材覆盖都市情感、悬疑推理与历史传奇等多个方向。业内认为，合拍模式有助于整合各方资源、拓展市场空间，也对创作团队的文化理解能力提出了更高要求。",
      "多位制片人表示，成功的合拍作品需要在保留各自文化特色的同时，找到能够引发共通情感的叙事切口，唯有如此才能真正打动不同文化背景的观众。",
      "相关项目预计将在未来一至两年内陆续与观众见面。",
    ],
    relatedIds: ["n004", "n002"],
  },
  {
    id: "n007",
    title: "《星河彼岸》北美定档，华语科幻走向国际市场",
    date: "2025-08-26",
    category: "海外发行",
    summary:
      "华语科幻电影《星河彼岸》确认将于下月登陆北美院线，成为又一部走向国际市场的国产科幻作品。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20deep%20space%20scene%20with%20a%20glowing%20planet%20and%20warm%20amber%20starlight%20in%20deep%20navy%20cosmos%2C%20editorial%20style%2C%20high%20detail&width=800&height=500&seq=news-cover-07&orientation=landscape",
    content: [
      "华语科幻电影《星河彼岸》确认将于下月正式登陆北美院线。该片此前已在多个国际影展进行展映，凭借独特的东方科幻美学获得海外媒体关注。",
      "导演叶南舟在采访中表示，影片试图在硬核科幻的外壳之下，探讨记忆、孤独与归途等具有普遍意义的主题，希望不同文化背景的观众都能从中获得共鸣。",
      "近年来，越来越多的华语作品开始尝试走向国际市场。业内认为，稳定的创作水准与鲜明的文化辨识度，是作品赢得海外观众认可的重要基础。",
      "影片的海外发行方表示，后续还将在更多国家和地区陆续安排上映。",
    ],
    relatedIds: ["n005", "n006"],
  },
  {
    id: "n008",
    title: "演技派回归：中年演员成为电视剧市场新宠",
    date: "2025-08-15",
    category: "行业观察",
    summary:
      "近两年，一批实力派中年演员凭借扎实的表演重新受到市场青睐，成为多部重点剧集的核心力量。",
    cover:
      "https://readdy.ai/api/search-image?query=Theater%20stage%20with%20warm%20amber%20spotlight%20and%20deep%20navy%20curtains%2C%20refined%20editorial%20style%2C%20high%20detail&width=800&height=500&seq=news-cover-08&orientation=landscape",
    content: [
      "近两年，一批实力派中年演员凭借扎实的表演重新受到市场青睐，成为多部重点剧集的核心力量。观众对于“有演技的好演员”的关注度持续走高。",
      "多位制作人透露，在选角过程中，演员与角色的贴合度以及对人物的理解能力，正成为越来越重要的考量标准。扎实的表演功底往往能为作品带来超出预期的质感提升。",
      "有评论认为，这一变化反映出观众审美的成熟——比起单纯的流量号召力，观众更愿意为真实、可信的表演买单。",
      "随着更多优质现实题材项目的推进，实力派演员的价值有望得到进一步体现。",
    ],
    relatedIds: ["n002", "n010"],
  },
  {
    id: "n009",
    title: "短剧集兴起，12集精品剧集模式受行业关注",
    date: "2025-08-02",
    category: "行业观察",
    summary:
      "篇幅短、节奏快的短剧集模式正受到越来越多创作者的关注，12集左右的精品剧集成新趋势。",
    cover:
      "https://readdy.ai/api/search-image?query=Minimalist%20editing%20desk%20with%20a%20laptop%20and%20film%20clapperboard%20under%20warm%20amber%20light%20with%20deep%20navy%20shadows%2C%20editorial%20style%2C%20high%20detail&width=800&height=500&seq=news-cover-09&orientation=landscape",
    content: [
      "篇幅短、节奏快的短剧集模式正受到越来越多创作者的关注。相比传统的长篇剧集，12集左右的精品剧集以紧凑的叙事和较高的制作完成度，赢得了观众的青睐。",
      "创作者认为，较短的篇幅有助于把注意力集中在核心故事上，避免情节注水。同时，相对可控的制作周期也让创作团队有更多精力打磨细节。",
      "从市场反馈来看，短剧集在年轻观众中尤其受欢迎，其灵活的观看节奏更契合当下的生活作息。",
      "业内预计，未来短剧集与传统长剧将形成互补共存的格局，为观众提供更加丰富的选择。",
    ],
    relatedIds: ["n003", "n002"],
  },
  {
    id: "n010",
    title: "影视行业年度报告：观众更青睐高质量原创内容",
    date: "2025-07-20",
    category: "行业观察",
    summary:
      "最新发布的影视行业年度报告显示，观众对高质量原创内容的偏好持续增强，原创能力成为核心竞争力。",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20data%20visualization%20dashboard%20on%20a%20screen%20with%20warm%20amber%20charts%20and%20deep%20navy%20background%2C%20editorial%20style%2C%20high%20detail&width=800&height=500&seq=news-cover-10&orientation=landscape",
    content: [
      "最新发布的影视行业年度报告显示，观众对高质量原创内容的偏好持续增强，原创能力正成为影视机构的核心竞争力之一。",
      "报告指出，具备鲜明个人风格与扎实叙事功底的原创作品，在口碑与市场表现上普遍优于同质化严重的内容。观众对“套路化”创作的容忍度正在下降。",
      "与此同时，报告也提到，观众对内容的选择渠道日趋多元，社交平台上的口碑传播对作品影响力的作用愈发显著。",
      "业内专家建议，创作机构应将更多资源投向剧本开发与人才储备，以原创力驱动长期发展。",
    ],
    relatedIds: ["n002", "n008"],
  },
];